module.exports = __webpack_public_path__ + "img/91473289.7d956f24.png";